var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProductActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "project-blueprint-buildings") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "STENI-pattern-generator",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "choose-product-menu-open-pre",
    transform: "translate(-742.000000, -232.000000)",
    stroke: "#E13527",
    strokeWidth: 1.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy",
    transform: "translate(698.000000, 196.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "project-blueprint-buildings",
    transform: "translate(44.000000, 36.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 3.75,
    cy: 20.25,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.75,20.25 L0.75,3.75 C0.75,2.09314575 2.09314575,0.75 3.75,0.75 C5.40685425,0.75 6.75,2.09314575 6.75,3.75 L6.75,20.25",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75,23.25 L21.75,23.25 C22.5784271,23.25 23.25,22.5784271 23.25,21.75 L23.25,6 C23.25,5.17157288 22.5784271,4.5 21.75,4.5 L6.75,4.5",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,18.75 L18,18.75 L18,9 C18,8.58578644 17.6642136,8.25 17.25,8.25 L12.75,8.25 C12.3357864,8.25 12,8.58578644 12,9 L12,18.75 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,12 L18,12",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,15 L18,15",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5,18.75 L18,18.75",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,18.75 L10.5,18.75",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProductActive);
export default __webpack_public_path__ + "static/media/icon-product-active.5044743c4bfb4af58314dfcd0ac127d4.svg";
export { ForwardRef as ReactComponent };